import { useCallback, useState } from 'react';
import { getBookingSnapshots } from '../../../api/bookingSnapshots';
import { SnapshotStatsData } from '../interfaces';

export const useBookingSnapshots = () => {
    const [snapshots, setSnapshots] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [stats, setStats] = useState<SnapshotStatsData | null>(null);
    const [total, setTotal] = useState<number>(0);

    const fetchSnapshots = useCallback(async ({
        workspaceID, startDate, endDate, groupBy = 'booking',
    }: { workspaceID: string; startDate: string; endDate: string; groupBy: string }) => {
        if (!workspaceID) {
            setSnapshots([]);
            return;
        }
        setLoading(true);
        try {
            const res: any = await getBookingSnapshots({
                workspaceID, startDate, endDate, order: 'ASC', groupBy,
            });
            setSnapshots(res?.data?.data?.snapshots || []);
            setStats(res?.data?.data?.stats || null);
            setTotal(res?.data?.data?.total || 0);
        } catch (e) {
            setSnapshots([]);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        snapshots, loading, fetchSnapshots, stats, total,
    };
};
